interface Item  {
    key: string,
    label?: string,
    icon?: string,
    slot?: string,

}
export interface PartitionItem extends Item {
    icon?: string,
    link?: string,
    children?: PartitionItem[],
    childLimit?: number,
    limitLabel?: string,
}

export default class NavService {
    public products: PartitionItem[];
    private _isWide: boolean = false;
    public currentActiveKey: Item['key'];
    // 子被展开的项
    public lv2ExpandedList: Item["key"][] = [];
    public functionLinks: PartitionItem[];
    public partitions: (PartitionItem | string)[];
    public allowMultiExpand: boolean = true;
    public onlyLv2Link: boolean = true;
    public tooltipTransition:string = 'el-fade-in-linear';
    // 是否在非wide模式下的图标下方显示label
    public showLabelUnderIcon = false
    static getDefProducts():PartitionItem[] {
        return [
        ];
    }

    static getDefFunctionLinks():PartitionItem[] {
        return [
            {
                key: 'workspace',
                icon: 'SolidWorkspace',
                children: [
                    {key: 'my_workspace'},
                    {key: 'shared_workspace'},
                    {key: 'public_workspace'}
                ]
            },
            { key: 'dashboard', icon: 'SolidChartDonut2' },
            { key: 'alert', icon: 'SolidEmailAlerts' },
        ];
    }

    constructor() {
        this.products = NavService.getDefProducts();
        this.functionLinks = NavService.getDefFunctionLinks();
        this.currentActiveKey = 'home'
        this.partitions = [...this.functionLinks, 'Tools', ...this.products]
    }

    public $t(str:string):string {
        return str
    }

    // @ts-ignore
    public toggleWideHook(bol:boolean) {}
    get isWide():boolean {
        return this._isWide
    }
    set isWide(bol) {
        if(bol !== this._isWide) {
            this.toggleWideHook(bol);
            this._isWide = bol
        }
    }

    public onClickedLinkHook(key:Item['key'], product:PartitionItem) {
        console.log(`Clicked: `, key, product)
    }

    public toggleExpandLv2(key:Item['key'], bol?:boolean) {
        const targetItemModel = getFlattedItemModels(this.partitions)
            .filter(itemModel => itemModel.key === key);
        const parentKey = targetItemModel[0]?.children && targetItemModel[0]?.children.length > 0
            ? key
            : targetItemModel[0]?.parent?.key || key;

        const _bol = bol === undefined ? !this.isExpanded(parentKey) : bol;

        if(_bol) {
            if(!this.allowMultiExpand) {
                this.lv2ExpandedList = [];
            }
            this.lv2ExpandedList.push(parentKey)
        } else {
            this.lv2ExpandedList = this.lv2ExpandedList.filter(str => str !== parentKey)
        }
        
    }

    public setExpandedKey(key:Item['key']) {
        if (!this.lv2ExpandedList.includes(key)) {
            this.lv2ExpandedList.push(key);
        }
    }

    public openTipLv2Hook(isTooltipShow:boolean){
        console.log(`Open:  master_nav-item__2nd_lv_wrap__popover`, isTooltipShow)
    }

    public onClickedMoreHook(key:Item['key'], product:PartitionItem) {
        console.log(`Clicked More: `, key, product)
    }

    protected getIsChildActive(itemKey:Item['key'], partitions: (PartitionItem | string)[] = this.partitions){
        const targetFunctionLink = partitions
            .filter(partition => typeof partition !== "string")
            // @ts-ignore
            .filter(functionLink => functionLink.key === itemKey)[0] as PartitionItem;

        if(!targetFunctionLink || !targetFunctionLink.children){
            return false
        }
        return targetFunctionLink.children.some(child => child.key === this.currentActiveKey)
    }

    protected isExpanded(key:Item['key']) {
        return this.lv2ExpandedList.includes(key)
    }
}

function getFlattedItemModels (partitions: (PartitionItem | string)[]) {
    class ItemModel {
        public allSubs: ItemModel[];
        constructor(readonly o:PartitionItem, readonly parent?:PartitionItem) {
            this.allSubs = [
                this,
                ...this.children
            ]
        }
        get key() {
            return this.o.key;
        }
        get children():ItemModel[] {
            const children = this.o.children || []
            return children.map(child => new ItemModel(child, this))
        }
    }

    const flattedItemModels: ItemModel[] = partitions
        .reduce((acc: ItemModel[], current: PartitionItem | string) => {
            if (typeof current !== "string") {
                const itemModel = new ItemModel(current)
                return acc.concat(itemModel.allSubs)
            } else {
                return acc
            }
        }, [])
    return flattedItemModels
}
